var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useQuery } from 'react-query';
import { useAxios } from 'shared/hooks';
import { reactionTypeSortOrder } from '../constants';
export var useMemberAllergies = function (memberUserId) {
    var axios = useAxios();
    return useQuery(['member-allergies', memberUserId], function () { return axios.get("/api/v1/users/".concat(memberUserId, "/allergies")); }, {
        select: function (response) {
            var _a, _b, _c, _d, _e, _f;
            // Group by reaction type, then sort by most recently added
            return (__assign(__assign({}, (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.data), { allergies: (_f = (_e = (_d = (_c = (_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.allergies) === null || _d === void 0 ? void 0 : _d.map(function (a, i) { return ({ allergy: a, index: i }); })) === null || _e === void 0 ? void 0 : _e.sort(function (a, b) {
                    return a.allergy.reactionType === b.allergy.reactionType
                        ? b.index - a.index
                        : reactionTypeSortOrder.indexOf(a.allergy.reactionType) -
                            reactionTypeSortOrder.indexOf(b.allergy.reactionType);
                })) === null || _f === void 0 ? void 0 : _f.map(function (a) { return a.allergy; }) }));
        },
        enabled: !!memberUserId,
        refetchOnMount: false,
    });
};
